<template>
  <div>
    <div class="dataTitle">
      <van-icon
        class="hospiyalsArrowLeft"
        style="top: 16px;"
        name="arrow-left"
        @click="onBack"
      />
      <div class="title">{{name}}</div>
    </div>
    <img class="imgStyle" :src="url" v-if="code==3||code==4" />
    <div id="demo" v-else-if="code==2"></div>
    <iframe class="embed" :src="url" v-else></iframe>
  </div>
</template>

<script>
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
import axios from 'axios';
export default {
  name: 'Images',
  components: {
  },
  data() {
    return {
      url: "",
      name: "",
      code: "",
      pdfh5: null
    };
  },
  methods: {
    onBack() {
      this.$router.go(-1);
    },
  },
  created(){
    this.url = this.$route.query.url
    this.name = this.$route.query.name
    this.code = this.$route.query.code
  },
  mounted(){
    if(this.code == 2){
      axios
      .get(this.url, {
        responseType: 'arraybuffer'
      })
      .then(res => {
        this.pdfh5 = new Pdfh5('#demo', {
          data: res.data
        });
      });
    }
    
    // //实例化
    // console.log( this.url )
    // this.pdfh5 = new Pdfh5("#demo", {
    //   pdfurl: '../../../assets/test.pdf'
    // });
    // this.pdfh5.on("complete", function (status, msg, time) {
		//  console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
	  // })

  }
};
</script>

<style scoped>
  .embed,#demo{
    width: 100%;
    height: calc(100vh - 55px);
    margin-top: 55px;
  }
  .imgStyle{
    width: 100%;
    margin-top: 55px;
  }
  .title{
    font-size: 16px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
